import api from './api';

export interface TaxBracket {
  id?: string;
  minIncome: number;
  maxIncome?: number; // null means no upper limit
  taxRate: number;
  bracketOrder?: number;
}

export interface TaxConfiguration {
  id: string;
  userId: string;
  jurisdiction: string;
  incomeTaxRate?: number; // null if using tax brackets
  socialSecurityRate?: number; // Legacy field
  employeeSocialSecurityRate?: number;
  employerSocialSecurityRate?: number;
  taxFreeAllowance: number;
  currency: string;
  additionalRules?: any;
  effectiveFrom?: string; // ISO date string
  effectiveTo?: string; // ISO date string
  isActive: boolean;
  description?: string;
  taxBrackets?: TaxBracket[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateTaxConfigData {
  jurisdiction: string;
  incomeTaxRate?: number;
  socialSecurityRate?: number; // Legacy
  employeeSocialSecurityRate?: number;
  employerSocialSecurityRate?: number;
  taxFreeAllowance?: number;
  currency?: string;
  additionalRules?: any;
  effectiveFrom?: string;
  effectiveTo?: string;
  isActive?: boolean;
  description?: string;
  taxBrackets?: TaxBracket[];
}

export interface UpdateTaxConfigData extends Partial<CreateTaxConfigData> {}

export const taxConfigApi = {
  getAll: async (params?: {
    jurisdiction?: string;
    activeOnly?: boolean;
    effectiveDate?: string;
  }): Promise<TaxConfiguration[]> => {
    const response = await api.get('/tax-config', { params });
    return response.data.data;
  },

  getByJurisdiction: async (
    jurisdiction: string,
    effectiveDate?: string
  ): Promise<TaxConfiguration> => {
    const response = await api.get(`/tax-config/jurisdiction/${jurisdiction}`, {
      params: effectiveDate ? { effectiveDate } : {},
    });
    return response.data.data;
  },

  getById: async (id: string): Promise<TaxConfiguration> => {
    const response = await api.get(`/tax-config/${id}`);
    return response.data.data;
  },

  create: async (data: CreateTaxConfigData): Promise<TaxConfiguration> => {
    const response = await api.post('/tax-config', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateTaxConfigData): Promise<TaxConfiguration> => {
    const response = await api.put(`/tax-config/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/tax-config/${id}`);
  },
};






